import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  asSeenWrap: FelaCSS;
  suggestionsWrap: FelaCSS;
  topWrap: FelaCSS;
  mainBox: FelaCSS;
  mainTitle: FelaCSS;
  secondTitle: FelaCSS;
}

const mainBoxShared: FelaCSS = {
  backgroundColor: colors.blueCrush,
  borderRadius: '6px',
};

const mainBoxDesktop: FelaCSS = {
  marginTop: '140px',
  marginBottom: '165px',
  marginRight: '15%',
  marginLeft: '0',
  paddingTop: '65px',
  paddingRight: '65px',
  paddingBottom: '65px',
  paddingLeft: '65px',
  ...mainBoxShared,
};

const mainBoxMobile: FelaCSS = {
  marginTop: '150px',
  marginBottom: '0px',
  marginRight: '0px',
  marginLeft: '0px',
  paddingTop: '46px',
  paddingRight: '24px',
  paddingBottom: '40px',
  paddingLeft: '24px',
  ...mainBoxShared,
};

const mainTitleShared: FelaCSS = {
  color: colors.white,
  marginTop: '0',
  fontDefault: 'inherit',
};

const mainTitleDesktop: FelaCSS = {
  fontDefaultSemiBold: 42,
  lineHeight: '42px',
  marginBottom: '32px',
  textAlign: 'left',
  ...mainTitleShared,
};

const mainTitleMobile: FelaCSS = {
  fontDefaultSemiBold: 38,
  lineHeight: '38px',
  marginBottom: '24px',
  textAlign: 'center',
  ...mainTitleShared,
};

const styles: IStyles = {
  wrapper: {
    display: 'inline-flex',
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },

  asSeenWrap: {
    backgroundColor: colors.space04,
    paddingTop: '30px',
    paddingRight: '15px',
    paddingBottom: '30px',
    paddingLeft: '15px',
    maxWidthTabletSm: {
      paddingBottom: 0,
      paddingTop: 0,
    },
  },

  suggestionsWrap: {
    width: '370px',
    alignSelf: 'auto',
    maxWidthTabletSm: {
      alignSelf: 'center',
      width: '90%',
    },
  },

  topWrap: {
    display: 'inline-flex',
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    backgroundImage: `url(https://image.bridebook.com/assets/img-reviews-desktop.jpg)`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    maxWidthTabletSm: {
      backgroundImage: `url(https://image.bridebook.com/assets/img-reviews-mobile.jpg)`,
    },
  },

  mainBox: {
    ...mainBoxDesktop,
    maxWidthTabletSm: {
      ...mainBoxMobile,
    },
  },

  mainTitle: {
    ...mainTitleDesktop,
    maxWidthTabletSm: {
      ...mainTitleMobile,
    },
  },

  secondTitle: {
    color: colors.white,
    fontDefault: 20,
    lineHeight: '20px',
    marginTop: '0',
    marginBottom: '16px',
    textAlign: 'left',
    maxWidthTabletSm: {
      fontDefault: 18,
      lineHeight: '18px',
      textAlign: 'center',
    },
  },
};

export default styles;
